import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { useSettings } from './lib/settings';
import { Live } from './pages/Live';
import { Killfeed } from './pages/Killfeed';
import { Overlay } from './pages/Overlay';
import { Reader } from './pages/Reader';
import { Settings } from './pages/Settings';
import { Start } from './pages/Start';

export function App() {
  const { appLang } = useSettings();
  useEffect(() => {
    document.documentElement.lang = appLang;
  }, [appLang]);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/live/:username" element={<Live />} />
        <Route path="/reader/:username" element={<Reader />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/overlay" element={<Overlay />} />
        <Route path="/overlay/killfeed" element={<Killfeed />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
